import styled from 'styled-components';
import Text from '../../../../../../components/Text';
import StatisticItem from '../../../components/StatisticItem';
import IcMoney from '../../../../../../components/Icon/icons/IcMoney';
import IcMarketing from '../../../../../../components/Icon/icons/IcMarketing';
import { IGetSummaryReportSMSResponse } from '../../../../interfaces/apis';
import { formatCurrency } from '../../../../../../utils/formatCurrency';
import IcOTP from '../../../../../../components/Icon/icons/IcOTP';
import IcAppointment from '../../../../../../components/Icon/icons/IcAppointment';
import IcSMS from '../../../../../../components/Icon/icons/IcSMS';

interface ReportSMSSummaryProps {
  data: IGetSummaryReportSMSResponse | null;
}
const ReportSMSSummary = ({ data }: ReportSMSSummaryProps) => {
  return (
    <Container>
      <Text variant='H5' style={{ fontWeight: 600 }}>
        Report SMS
      </Text>
      <Content>
        <StatisticItem label='SMS Cost' value={formatCurrency(data?.totalCost || 0)} icon={<IcMoney fill='#EBA33B' width={48} height={48} />} />
        <StatisticItem label='SMS OTP' value={data?.totalOtp || 0} icon={<IcOTP fill='#DC5500' width={48} height={48} />} />
        <StatisticItem label='SMS Marketing' value={data?.totalMarketing || 0} icon={<IcMarketing fill='#0DA472' width={48} height={48} />} />
        <StatisticItem label='SMS Appointment' value={data?.totalAppointment || 0} icon={<IcAppointment fill='#008BFF' width={48} height={48} />} />
        <StatisticItem label='SMS Others' value={data?.totalOthers || 0} icon={<IcSMS fill='#9747FF' width={48} height={48} />} />
      </Content>
    </Container>
  );
};

export default ReportSMSSummary;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
`;
